import { domain } from 'modules/data';

import { CompanyInfo } from './isPayAvailableViaLicense.types';

export const isPayAvailableViaLicense = (companyInfo: CompanyInfo) =>
    companyInfo.licenseFeatures.includes(domain.CompanyLicenseFeature.Pay) &&
    (![domain.CompanyPlan.Trial, domain.CompanyPlan.Partner, domain.CompanyPlan.Retired].includes(
        companyInfo.licenseProductPlan
    ) ||
        ([domain.CompanyPlan.Trial, domain.CompanyPlan.Partner, domain.CompanyPlan.Retired].includes(
            companyInfo.licenseProductPlan
        ) &&
            companyInfo.integration?.countryCode === 'UnitedKingdom'));
